import React from "react";
import { useParams } from "react-router-dom";
import Seo from "../components/site/Seo";
import Reveal from "../components/site/Reveal";
import { SectionLabel, ArrowLink } from "../components/site/Bits";
import NotFound from "./NotFound";
import { LEGAL_PAGES, COMPANY } from "../lib/content";

export default function Legal() {
  const { slug } = useParams();
  const page = LEGAL_PAGES[slug];

  if (!page) return <NotFound />;

  return (
    <>
      <Seo
        title={`${page.title} | LYKIT Entertainment Pvt. Ltd.`}
        description={`${page.title} for ${COMPANY.legalName}.`}
        path={`/legal/${slug}`}
      />

      <section
        className="cinematic"
        style={{ paddingTop: "clamp(120px,13vh,158px)", paddingBottom: "clamp(34px,3.4vw,56px)" }}
      >
        <div className="lk-container">
          <SectionLabel onDark>{page.eyebrow}</SectionLabel>
          <h1 className="display-lg mt-7" style={{ color: "#FBFAF7" }} data-testid="legal-title">
            {page.title}
          </h1>
          <p className="mt-6 text-[13px]" style={{ color: "rgba(247,246,242,0.6)" }}>
            {page.updated}
          </p>
        </div>
      </section>

      <section className="lk-section">
        <div className="lk-container">
          <div style={{ maxWidth: "70ch" }}>
            {page.sections.map((section, i) => (
              <Reveal key={section.heading} delay={i * 0.04} className="mb-12">
                <h2 className="display-sm" style={{ fontFamily: "Manrope, sans-serif" }}>
                  {section.heading}
                </h2>
                <div className="mt-5 space-y-4">
                  {section.body.map((paragraph) => (
                    <p key={paragraph} className="text-[15px] leading-[1.7] body-muted">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </Reveal>
            ))}

            <div className="mt-4 flex flex-wrap items-center gap-8">
              <ArrowLink href={`mailto:${COMPANY.email}`} data-testid="legal-email-link">
                {COMPANY.email}
              </ArrowLink>
              <ArrowLink to="/contact">Contact LYKIT</ArrowLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
